import React, { useRef, useEffect } from 'react'
import FollowupTable from './FollowupTable';
import MessageBtn from './MessageBtn';

const FollowupDetails = ({ isDetails, setIsDetails }) => {

    const detailsRef = useRef();

    useEffect(() => {
        document.addEventListener('mousedown', (e) => {
            if (!detailsRef.current.contains(e.target)) {
                setIsDetails(false)
            }
        });
    });

    const followTable = [
        {
            Sno: 1,
            fDate: '2022-12-03',
            fTime: '01:20 pm',
            remarks: 'hello'
        },
        {
            Sno: 2,
            fDate: '2022-12-03',
            fTime: '01:20 pm',
            remarks: 'hello'
        }
    ];

    return (
        <>
            <div className={`h-full w-full bg-[rgba(0,0,0,0.6)] z-40 fixed inset-0 ${isDetails ? "block" : "hidden"}`}>
            </div>
            <div ref={detailsRef} className={` h-3/5 w-11/12 md:h-3/4 lg:w-4/5 xl:h-5/6 xl:w-3/5 fixed left-1/2 -translate-x-1/2 -translate-y-1/2 z-40  bg-white shadow-2xl rounded-lg ${isDetails ? "top-1/2" : "-top-full"} transition-all ease-linear duration-500`}>
                <div className='flex justify-center items-center pt-4 pb-2'>
                    <h3 className='text-sm md:text-base text-gray-700 text-center basis-11/12'>Follow-Up Details</h3>
                    <i className="fa-solid fa-xmark basis-1 text-gray-700 cursor-pointer block opacity-40 hover:opacity-80 animation" onClick={() => setIsDetails(false)}></i>
                </div>
                <FollowupTable followTable={followTable} />
            </div>
        </>
    )
}

export default FollowupDetails;